import type { KeptRef } from './KeepActions';

export function resolveKeptRef(
  refs: ReadonlyMap<string, KeptRef> | undefined,
  key: string,
  fallbackContentId: number | null,
  fallbackCode: string | null
): KeptRef | null {
  if (refs !== undefined) {
    const ref = refs.get(key);
    return ref ? { contentId: ref.contentId, code: ref.code } : null;
  }
  return fallbackContentId !== null && fallbackCode !== null ? { contentId: fallbackContentId, code: fallbackCode } : null;
}
